import { useEffect } from "react"

// Helper used by HtmlModal and Html to add / remove tags in <Head></Head>
export default ( addToDocumentHead ) => {    
  if (typeof document !== 'undefined') { // I.e. we're not in Node / server
  
    const head = document.head
    let headerNodes = []

    if( !addToDocumentHead ) {
      return
    }

    // addToHeader is a long text field in Contentful. It's purpose is to add <script> <style> or <meta> tags in the document <head>
    // I can not get react-static Head to work when the entire tag is dynamic. Hence creating and appending this way.
    useEffect(() => {

      // create DOM elements from the addToHeader string coming from contentful by creating a template element
      let templateEl = document.createElement( 'template' )

      // setting innerHTML creates the HTML nodes
      templateEl.innerHTML = addToDocumentHead

      // iterate over the created nodes and append to document head 
      for( let i = 0; i < templateEl.content.childNodes.length; i++ ) {

        // do some 'magic' if it's a script node. i.e explicitly create a new script node instead of just adding the node as created by the templateEl 
        // as that does not always load the script... 
        if( templateEl.content.childNodes[i] instanceof(HTMLScriptElement) ) {

          let scriptNode = document.createElement( 'script' )
          scriptNode.type = 'text/javascript'
          scriptNode.defer = templateEl.content.childNodes[i].defer
          // force all scripts added through HTML Snippet to load async
          scriptNode.async = 'async'
          scriptNode.src = templateEl.content.childNodes[i].src
          headerNodes.push( head.appendChild( scriptNode ) )

        } else {

          headerNodes.push( head.appendChild( templateEl.content.childNodes[i] ) )

        }

      }

      // cleanup, i.e remove anything we added
      return () => {

        for( let i = 0; i < headerNodes.length; i++ ) {
          head.removeChild( headerNodes[i] )
        }

      }

    }, [])

  }
}
